<template>

<div class="page">

    <div class="page-head">

        <div class="page-head-inner">

            <div class="page-head-logo"><span>ADNAT</span></div>

            <div class="page-head-title">{{ title }}</div>

            <div class="page-head-links">

                <router-link v-if="back" :to="($_.isObject(back)) ? back : {name: back}" class="page-head-links-item is-back">Back</router-link>

                <router-link v-if="!back && $isOrganisation" :to="{name: 'Hospitals'}" class="page-head-links-item">Hospitals</router-link>
                
                <router-link v-if="!back && $isOrganisation" :to="{name: 'Users'}" class="page-head-links-item">Users</router-link>
                
                <router-link v-if="!back && $isAdmin" :to="{name: 'Users'}" class="page-head-links-item">Data Users</router-link>
                
                <router-link v-if="!back && $isClinic" :to="{name: 'Patients'}" class="page-head-links-item">Patients</router-link>

                <router-link :to="{name: 'Logout'}" class="page-head-links-item">Log Out</router-link>

            </div>

        </div>

    </div>

    <div class="page-content" v-show="!isLoading">

        <slot></slot>

    </div>

    <div class="page-loading" v-show="isLoading">

        Please wait, loading...

    </div>

</div>

</template>

<script>

export default {

    props: ['title', 'back', 'isLoading']

}

</script>

<style scoped>

.page-head {
    height: 110px;
    background-color: #E8EDEE;
}

.page-head-inner {
    max-width: 1280px;
    width: 100%;
    height: 110px;
    margin: 0px auto;
    display: grid;
    grid-template-columns: 156px auto auto;
    align-items: center;
    grid-gap: 40px;
}

.page-head-logo {
    width: 156px;
    height: 44px;
    background-image: url(~@/assets/logo.png);
    background-size: 156px 44px;
}

.page-head-logo span {
    display: none;
}

.page-head-title {
    color: #425563;
    font-size: 24px;
    font-weight: 300;
    text-transform: uppercase;
}

.page-head-links {
    display: flex;
    justify-content: flex-end;
}

.page-head-links-item {
    margin-left: 20px;
    height: 52px;
    border-radius: 50px;
    box-shadow: 0px 3px 3px #00000029;
    background-color: #fff;
    color: #425563;
    font-size: 16px;
    font-weight: 500;
    padding: 0px 36px;
    line-height: 52px;
}

.page-head-links-item:hover {
    background-color: #b8b8b8;
}

.page-head-links-item.is-back:before {
    content: '<';
    margin-right: 10px;
}

.page-content {
    padding: 40px 0px;
    max-width: 1280px;
    width: 100%;
    margin: 0px auto;
}

.page-loading {
    height: 240px;
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #666;
    align-items: center;
}

</style>
